module.exports = __webpack_public_path__ + "static/media/thankyou_mobile.0b255f8d.png";